import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'

import styles from './default-address-item.css'
import IconEdit from '@assets/images/icons/pencil.svg'
import CloseSvg from '@assets/images/icons/v2/close.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import { useTheme } from '@mui/styles'

const DefaultAddressItem = (props) => {
  const {
    title,
    children,
    onEdit,
    onDelete,
    onEditIcon,
    showAction = true,
    readOnly,
    actionItemClassName,
    detailsItemClassName,
    actionDeleteItemClassName,
    actionEditItemClassName,
    customClass,
  } = props
  const theme = useTheme()

  const action = showAction
    ? (
      <div className={clsx(styles.defaultItemActionContainer, actionItemClassName)}>
        {(!readOnly && onDelete) && <div className={clsx(styles.defaultItemAction, actionDeleteItemClassName)} onClick={onDelete}>
          <SVGIcon svg={CloseSvg} height='10px' width='10px' />
        </div>
        }
        {(!readOnly && (onEdit || onEditIcon)) && <div className={clsx(styles.defaultItemAction, actionEditItemClassName)} onClick={onEditIcon || onEdit}>
          <SVGIcon svg={IconEdit} height='10px' width='10px' fill={theme.white} />
        </div>
        }
      </div>
    )
    : null

  return (
    <div className={clsx(styles.defaultItem, customClass)}>
      <span className={styles.defaultItemTitle}>{title}</span>
      <div className={showAction ? styles.defaultItemContent : styles.defaultItemContentWithoutEdit}>
        <div className={clsx(styles.defaultItemDetails, detailsItemClassName)} onClick={!readOnly && onEdit}>
          {children}
        </div>
        {action}
      </div>
    </div>
  )
}

DefaultAddressItem.propTypes = {
  customClass: PropTypes.string,
  actionDeleteItemClassName: PropTypes.string,
  actionEditItemClassName: PropTypes.string,
  actionItemClassName: PropTypes.string,
  detailsItemClassName: PropTypes.string,
  title: PropTypes.string,
  onEdit: PropTypes.func,
  onEditIcon: PropTypes.func,
  onDelete: PropTypes.func,
  children: PropTypes.node,
  readOnly: PropTypes.bool,
  showAction: PropTypes.bool,
}

export default DefaultAddressItem
